module.exports = __webpack_public_path__ + "static/media/device_activity.534265d0.png";